import './WhyChooseUs.css';
import { IconTrophy, IconPin, IconClock, IconShield } from './Icons';

const DIFFERENTIALS = [
  {
    icon: IconTrophy,
    title: 'Dedicação Exclusiva',
    text: 'Atendimento personalizado com foco total nas necessidades do seu negócio, do planejamento à entrega.',
  },
  {
    icon: IconPin,
    title: 'Visibilidade Total',
    text: 'Acompanhamento em tempo real da operação, com transparência em cada etapa do transporte.',
  },
  {
    icon: IconClock,
    title: 'Previsibilidade',
    text: 'Compromisso com prazos e previsibilidade operacional para manter sua cadeia logística funcionando.',
  },
  {
    icon: IconShield,
    title: 'Segurança Jurídica',
    text: 'Empresa regularizada e operação em conformidade, com responsabilidade e transparência em cada contrato.',
  },
];

function WhyChooseUs() {
  return (
    <section
      id="diferenciais"
      className="section-padding bg-dark-section"
      aria-labelledby="why-title"
    >
      <div className="container">
        <div className="text-center mb-5">
          <span className="section-badge">05</span>
          <p className="section-title">Diferenciais</p>
          <h2 id="why-title" className="section-heading">
            Nossos <span className="text-accent">diferenciais</span> competitivos
          </h2>
          <div className="red-divider red-divider-center" />
          <p className="section-subtitle">
            O que nos torna referência no transporte de cargas lotação e na
            prestação de serviços logísticos em todo o Brasil.
          </p>
        </div>

        <div className="row g-4">
          {DIFFERENTIALS.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.title} className="col-md-6 col-lg-3">
                <article className="feature-card h-100 text-center">
                  <div className="icon-circle mx-auto">
                    <Icon />
                  </div>
                  <h3 className="feature-title">{item.title}</h3>
                  <p className="feature-text">{item.text}</p>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
